<template>
  <div id="v-select" @mousedown="(e)=>{if(!disabled)handleOpenSelect(e)}">
    <a-select
      ref="vSelect"
      :allowClear="allowClear"
      :value="hookValue"
      :dropdownMatchSelectWidth="false"
      :mode="mode"
      :getPopupContainer="(triggerNode) => triggerNode.parentElement"
      :show-arrow="showSearch ? false : true"
      :show-search="true"
      :filter-option="false"
      :default-active-first-option="false"
      :maxTagCount="maxTagCount"
      :maxTagPlaceholder="maxTagPlaceholder"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="mode === 'default' ? {} : { open: selectOpen }"
      v-deselect
      class="v-select-main"
      :dropdownClassName="dropdownClassName"
      @deselect="handleDeselect"
      @mouseenter="$emit('mouseenter')"
      @search="(text) => filterOption(text)"
    >
      <template #clearIcon>
        <a-icon style="font-size: 14px;" type="close-circle"  @click.stop="handleClear" />
      </template>
      <div slot="dropdownRender" style="overflow: auto;">
        <a-spin tip="加载中..." :spinning="optionsLoading" >
          <div v-if="options.length">
            <template v-if="mode === 'multiple'">
              <a-input-search
                ref="multipleInputSearch"
                v-model="search"
                class="select-search-wrap"
                placeholder="搜索"
                @click.stop
                @change="filterOption(search)"/>
              <a-checkbox v-if="isSelectAll" class="check-item" :checked="selectValue.length === constHookOptions.length && selectValue.length > 0" @click.native.stop @change="selectAll">全选</a-checkbox>
            </template>
            <a-spin tip="查询中..." :spinning="searchLoading" >
              <RecycleScroller
                v-if="hookOptions.length"
                style="min-height: 32px; overflow:auto;"
                :style="{ maxHeight: maxHeight + 'px' }"
                type="default"
                :items="hookOptions"
                :item-size="32"
                :buffer="100"
                :mode="mode"
                :prop="{value: optionsFields.value, text: optionsFields.label}"
              >
                <template v-slot="{item}">
                  <div
                    class="check-item"
                    :class="{'selected': valueKey ? item[valueKey] === value : (value && item[optionsFields.value] === (value[optionsFields.value] || {}))}"
                    @click.stop="e => checkChange(item)"
                  >
                    <span v-if="mode === 'multiple'" class="check-box-pointer" :class="{checked: item.flag}" />
                    <slot v-if="labelSlots" name="label" v-bind="item"></slot>
                    <TextTooltip v-else placement="topLeft" :text="item[optionsFields.label]" />
                  </div>
                </template>
              </RecycleScroller>
            </a-spin>
          </div>
        </a-spin>
      </div>
    </a-select>
  </div>
</template>

<script>
import RecycleScroller from './components/RecycleScroller'
import deselect from './mixins/deselect'
import TextTooltip from '@/components/TextTooltip.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'VSelect',
  mixins: [deselect],
  components: {
    RecycleScroller,
    TextTooltip
  },
  props: {
    value: {
      default: () => []
    },
    type: {
      type: String,
      default: 'all'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    limitNum: {
      type: [Number],
      default: 100000
    },
    maxHeight: {
      default: 250
    },
    maxTagCount: {
      default: 1
    },
    labelSlots: {
      type: Boolean,
      default: false
    },
    isSelectAll: {
      type: Boolean,
      default: true
    },
    // 可切换对象
    tabList: {
      type: Array,
      default: () => []
    },
    // 以哪个tab为准
    primaryTab: {
      type: String,
      default: ''
    },
    dropdownClassName: { default: '' },
    placeholder: { default: '' },
    options: { default: () => [] },
    optionsFields: { default: () => ({ label: 'label', value: 'value' }) },
    // 下拉数据返回前状态
    optionsLoading: {
      type: Boolean,
      default: false
    },
    height: { default: 400 },
    valueKey: { default: undefined },
    mode: { default: 'default' } // default | multiple
  },
  data () {
    return {
      tabsCurrent: this.tabList && this.tabList.length ? this.tabList[0].value : '',
      search: '',
      isSearch: false,
      searchLoading: false,
      selectOpen: false,
      refresh: false,
      hookOptions: [],
      constHookOptions: [],
      selectValue: []
    }
  },
  computed: {
    hookValue () {
      if (this.valueKey) {
        const find = this.hookOptions.find(item => item[this.valueKey] === this.selectValue)
        return find ? find[this.optionsFields.label] : undefined
      } else {
        const _val = (Array.isArray(this.selectValue) ? this.selectValue : this.selectValue ? [this.selectValue] : [])
        return _val.map(row => row[this.optionsFields.label] || row)
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.selectValue = newValue
        if (this.selectValue && Array.isArray(this.selectValue) && this.selectValue.length) {
          if (this.selectValue.length === this.constHookOptions.length) {
            this.selectValue.forEach(k => {
              if (typeof k === 'object') {
                k.isAll = true
              }
            })
          } else {
            this.selectValue.forEach(k => {
              if (typeof k === 'object') {
                k.isAll = false
              }
            })
          }
        }
        this.$emit('change', newValue)
        const s = JSON.stringify
        if (s(newValue) === s(oldValue)) return
        this.valueMode(newValue)
      }
    },
    options: {
      immediate: true,
      handler: function (newValue) {
        this.hookOptions = (newValue || []).map((item, index) => ({ ...item, '$dataIndex': index }))
        this.constHookOptions = cloneDeep(this.hookOptions)
        this.valueMode(this.selectValue)
        // 获取焦点
        setTimeout(() => {
          if (!this.$refs.multipleInputSearch) {
            return
          }
          this.$refs.multipleInputSearch.$refs.input.focus()
        }, 200)
      }
    }
  },
  mounted () {
    if (this.mode === 'multiple') {
      const auction = document.querySelectorAll('#v-select .home-ant-select-search__field')
      auction.forEach(item => {
        item && item.setAttribute('readonly', 'true')
      })
    }
  },
  methods: {
    handleDeselect (value) {
      let selectedItem = ''
      if (Array.isArray(this.selectValue)) {
        selectedItem = this.selectValue.filter(item => item[this.optionsFields.label] !== value)
      }
      this.selectValue = selectedItem
      this.$emit('update:value', selectedItem)
      this.$emit('change', selectedItem)
    },
    handleClear() {
      this.selectValue = []
      this.$emit('update:value', this.selectValue)
      this.$emit('change', [])
    },
    changeTab (val) {
      const index = this.tabList.findIndex(k => k.value === val)
      this.$emit('handleOptions', { currentTab: val, label: this.tabList[index].label, primaryTab: this.primaryTab })
    },
    /* ----------------------------------------- 绑定方法 ----------------------------------------- */
    filterOption (text) {
      this.isSearch = true
      return new Promise((resolve) => {
        this.searchLoading = true
        if (this.type === 'all') {
          // 英文() 属于正则关键字 会被转义  （* . ? + $ ^ [ ] ( ) { } | \ /）都是正则关键字，所以不用正则匹配
          resolve(this.options.filter(row => row[this.optionsFields.label] && row[this.optionsFields.label].toLowerCase().indexOf(text.toLowerCase()) >= 0))
        } else {
          this.refresh = true
          this.$emit('search', text, data => resolve(data))
        }
      }).then(res => {
        this.searchLoading = false
        this.refreshHook(res)
      }).finally(() => {
        this.searchLoading = false
      })
    },
    checkChange (item) {
      const valueKey = this.optionsFields.value
      if (this.mode === 'multiple') {
        const index = this.selectValue.findIndex(it => it[valueKey] === item[valueKey])
        if (index > -1) {
          item.flag = false
          this.selectValue.splice(index, 1)
        } else {
          if (this.selectValue.length >= this.limitNum) return
          item.flag = true
          this.selectValue.push(item)
        }
        this.$emit('input', this.selectValue)
      } else {
        this.$emit('input', this.valueKey ? item[this.valueKey] : item)
      }
    },
    maxTagPlaceholder () {
      if (this.mode === 'multiple') return `+${this.hookValue.length - this.maxTagCount}`
    },
    /* ----------------------------------------- 自定义方法 ----------------------------------------- */
    refreshHook (res) {
      // 先清空在赋值目的是为了重新计算当前数据的滚动高度
      this.hookOptions = []
      setTimeout(() => {
        this.hookOptions = (res || []).map((item, index) => {
          const keys = this.optionsFields['value']
          if (this.mode === 'multiple') {
            const findIndex = this.selectValue.findIndex(row => row[keys] === item[keys])
            item.flag = findIndex > -1
          } else {
            item.flag = this.selectValue === item[keys]
          }
          return { ...item, '$dataIndex': index }
        })
      }, 0)
    },
    valueMode (newValue) {
      const keys = this.optionsFields['value']
      const valueType = Object.prototype.toString.call(newValue).slice(8, -1).toLocaleLowerCase()
      if (this.hookOptions.length === 0 || !newValue) return

      // 简单数据类型 -> TODO
      if (['number', 'string'].includes(valueType) && this.mode === 'default') {
        const index = this.hookOptions.findIndex(row => row[keys] === newValue)
        if (index > -1) {
          this.hookOptions[index].flag = true
          !this.valueKey && this.$emit('input', this.hookOptions[index])
        }
        return
      }
      // 数组类型(多选) -> TODO
      if (valueType === 'array' && this.mode === 'multiple' && newValue.length) {
        const _val = []
        newValue.forEach(element => {
          let dataValue = element[keys] || element
          // 处理为0时选不中的问题
          if (element[keys] === 0) {
            dataValue = 0
          }
          const index = this.hookOptions.findIndex(row => row[keys] === dataValue)
          if (index > -1) {
            this.hookOptions[index].flag = true
            _val.push(this.hookOptions[index])
          } else {
            _val.push(element)
          }
        })
        this.$emit('input', _val)
      }
    },
    // 点击打开下拉菜单
    handleOpenSelect (e) {
      if (this.mode === 'default' || this.selectOpen) return
      e.preventDefault()
      this.refreshHook(this.options)
      this.selectOpen = true
      // 获取焦点
      setTimeout(() => {
        if (!this.$refs.multipleInputSearch) {
          return
        }
        this.$refs.multipleInputSearch.$refs.input.focus()
      }, 200)
    },
    // 全选
    selectAll (e) {
      const checked = e.target.checked
      if (checked) {
        this.selectValue = cloneDeep(this.hookOptions)
        this.$emit('input', this.selectValue)
        this.$emit('update:value', this.selectValue)
        this.$emit('change', this.selectValue)
      } else {
        this.handleDelete()
      }
    },
    // 删除
    handleDelete () {
      this.hookOptions.map(item => {
        item.flag = false
      })
      this.selectValue = []
      this.$emit('input', this.selectValue)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.vue-recycle-scroller__item-view {
  min-width: 100%;
}
.vue-recycle-scroller__item-wrapper {
  overflow-y: hidden;
  .hover {
    .check-item {
      &:hover {
        background: rgba(7, 123, 252, .06);
      }
    }
    .select-ppt__item {
      &:hover {
        background-color: #fff;
      }
    }
  }
}

.check-item {
  width: 100%;
  height: 32px;
  line-height: 32px !important;
  padding-left: 11px;
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 11px !important;
  white-space: nowrap;
  &__label {
    display: inline-block;
    width: ~'calc(100% - 24px)';
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: bottom;
  }
  &:hover {
   background: #F0F4FF !important;
   cursor: pointer;
  }
  &.selected {
    color: #0B1019;
    font-weight: 600;
    background-color: #fafafa;
  }
  .check-box-pointer {
    margin-right: 8px;
    flex: none;
    outline: none;
    border: 1px solid #BCC1C9;
    width: 14px;
    height: 14px;
    background-color: #fff;
    font-feature-settings: "tnum";
    transition: all 0.25s;
    position: relative;
    border-radius: 2px;
    &.disabled {
      cursor:not-allowed
    }
  }
  .check-box-pointer.checked {
    background: #1E5AF9;
    border-color: #1E5AF9;
  }
}
.v-select-dropdown {
  min-width: 180px;
}
.select-search-wrap {
  padding: 10px;
}
.@{ant-prefix}-input-affix-wrapper .@{ant-prefix}-input-suffix {
  right: 20px;
}
</style>
